import { useState } from "react"
import {
  Block,
  LabelMedium,
  ModalBody,
  ModalFooter,
  useStyletron,
} from "@mezo-org/mezo-clay"

import bitcoinIcon from "#/assets/tokens/bitcoin-token-orange.svg"
import ProgressSteps, { NumberedStep } from "#/shared/components/ProgressSteps"
import { getTokenIcon } from "#/shared/utils"
import { ComponentStepProps, SignTransactionModalButton } from "#/ui/Modal"

import { useAddLiquidityFlowContext } from "../AddLiquidityFlowContext"

import DepositingAssetListItem from "./DepositingAssetListItem"

export default function Summary({ onClickContinue }: ComponentStepProps) {
  const [css, theme] = useStyletron()
  const { token1Amount, token2Amount } = useAddLiquidityFlowContext()

  // TODO: Check if the the user has enough approved tokens to add liquidity.
  // Use the `useReadContract` hook from the `wagmi` lib (`ERC20.allowance`
  // function). Otherwise the user must sign the `approve` transaction to
  // complete the flow. Set correct step based on approved tokens.
  const [currentStep] = useState(1)

  // TODO: Use the `useWriteContract` hook from `wagmi` lib to trigger the
  // `approve` transaction and control the loading state of the `SlideUpMenu`
  // component and button inside the `ApproveTokenListItem`.
  // const isApprovingToken1 = false
  // const isApprovingToken2 = false

  // TODO: User must approve enough tokens to spend to complete the flow.
  const isContinueButtonDisabled = false

  return (
    <>
      <ModalBody
        $style={() => ({
          display: "flex",
          flexDirection: "column",
          height: "100%",
        })}
      >
        <LabelMedium color="contentPrimary" marginBottom="scale800">
          Depositing assets
        </LabelMedium>
        <Block
          as="ul"
          className={css({ li: { marginBottom: theme.sizing.scale300 } })}
        >
          <DepositingAssetListItem
            amount={token1Amount!}
            icon={getTokenIcon("MUSD")}
          />
          <DepositingAssetListItem amount={token2Amount!} icon={bitcoinIcon} />
        </Block>
        <ProgressSteps currentStep={currentStep}>
          <NumberedStep title="Approve MUSD" isPending />
          <NumberedStep title="Approve BTC" isPending />
          <NumberedStep title="Add assets to pool" isPending={false} />
        </ProgressSteps>
      </ModalBody>
      <ModalFooter
        $style={{ justifyContent: "stretch", flexDirection: "column" }}
      >
        <SignTransactionModalButton
          disabled={isContinueButtonDisabled}
          onClick={onClickContinue}
          gasFee="$1.2"
          buttonLabel="Add liquidity"
        />
      </ModalFooter>
    </>
  )
}
